<template>
    <div class="status card">
        <div class="status__title"><i class="fas fa-cogs"></i> Check-In Status</div>
        <div class="container-fluid my-3">
            <div class="row">
                <div class="col-lg-3">
                    <div class="card">
                        <div class="card-body">
                            <!-- System Status -->
                            <h6 class="status__subtitle mb-0">System Status</h6>
                            <p v-if="status && status.closed == 0" class="card-text mb-2">
                                <span class="badge badge-success">Open</span>
                            </p>
                            <p v-else class="card-text mb-2 status__subheader">
                                <span class="badge badge-warning">Closed</span> -
                                {{ status && status.closureType && status.closureType.type ? status.closureType.type : "N/A" }}
                            </p>
                            <!-- Capacity Threshold -->
                            <h6 class="status__subtitle mb-0">Capacity Threshold</h6>
                            <p v-if="status && status.capacityThreshold" class="card-text mb-2">
                                {{ status.capacityThreshold }}%
                            </p>
                            <p v-else class="card-text mb-2">
                                N/A
                            </p>
                            <!-- Capacity Threshold Met -->
                            <h6 class="status__subtitle mb-0">Capacity Threshold Met</h6>
                            <p v-if="status && status.capacityThresholdMet == 0" class="card-text mb-2">
                                <span class="badge badge-success">No</span>
                            </p>
                            <p v-else class="card-text mb-2">
                                <span class="badge badge-warning">Yes</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="card">
                        <div class="card-body">
                            <!-- Show Weekday Message -->
                            <h6 class="status__subtitle">{{ getCurrentDate }}</h6>
                            <!-- Weekday Message -->
                            <h6 class="status__subtitle mb-0">Weekday Message</h6>
                            <p class="card-text">
                                <span v-if="status && status.showWeekdayMessage && status.showWeekdayMessage == 1"
                                    class="badge badge-success" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Weekday Message: Yes" title="Show Weekday Message: Yes"><i
                                        class="fas fa-check"></i></span>
                                <span v-else class="badge badge-danger" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Weekday Message: No" title="Show Weekday Message: No"><i
                                        class="fas fa-ban"></i></span> -
                                {{ status && status.weekdayMessage ? status.weekdayMessage : "N/A" }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="card">
                        <div class="card-body">
                            <!-- Kiosk Check-In -->
                            <h6 class="status__subtitle mb-0">Kiosk Check-In Status</h6>
                            <p v-if="status && status.closed == 0 && status.checkinKiosk && status.checkinKiosk.open == 1"
                                class="card-text mb-2">
                                <span class="badge badge-success">Open</span>
                            </p>
                            <p v-else class="card-text mb-2">
                                <span class="badge badge-warning">Closed</span>
                            </p>
                            <!-- Kiosk Message -->
                            <h6 class="status__subtitle mb-0">Closed Message</h6>
                            <p class="card-text">
                                <span v-if="status && status.checkinKiosk && status.checkinKiosk.showClosedMessage == 1"
                                    class="badge badge-success" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Kiosk Message: Yes" title="Show Kiosk Message: Yes"><i
                                        class="fas fa-check"></i></span>
                                <span v-else class="badge badge-danger" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Kiosk Message: No" title="Show Kiosk Message: No"><i
                                        class="fas fa-ban"></i></span> -
                                {{ status && status.checkinKiosk ? status.checkinKiosk.closedMessage : "N/A" }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="card">
                        <div class="card-body">
                            <!-- Virtual Check-In -->
                            <h6 class="status__subtitle mb-0">Virtual Check-In Status</h6>
                            <p v-if="status && status.closed == 0 && status.checkinVirtual && status.checkinVirtual.open == 1"
                                class="card-text mb-2">
                                <span class="badge badge-success">Open</span>
                            </p>
                            <p v-else class="card-text mb-2">
                                <span class="badge badge-warning">Closed</span>
                            </p>
                            <!-- Virtual Message -->
                            <h6 class="status__subtitle mb-0">Closed Message</h6>
                            <p class="card-text">
                                <span
                                    v-if="status && status.checkinVirtual && status.checkinVirtual.showClosedMessage == 1"
                                    class="badge badge-success" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Virtual Message: Yes" title="Show Virtual Message: Yes"><i
                                        class="fas fa-check"></i></span>
                                <span v-else class="badge badge-danger" data-toggle="tooltip" data-placement="bottom"
                                    data-original-title="Show Virtual Message: YNoes"
                                    title="Show Virtual Message: No"><i class="fas fa-ban"></i></span> -
                                {{ status && status.checkinVirtual ? status.checkinVirtual.closedMessage : "N/A" }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dashboard-status',
    props: {
        status: {
            required: true,
            type: Object
        }
    },
    computed: {
        getCurrentDate() {
            let date = new Date();
            return `${date.toDateString()}`;
        }
    }
}
</script>

<style scoped>
.status {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.status__subheader {
    text-transform: capitalize;
}

.status__subtitle {
    color: #48465b;
    font-weight: 600;
}

.status__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    min-height: 64px;
    padding: 16px 20px;
}

.status__title>i {
    color: #5d78ff;
    font-size: 1.25rem;
}
</style>